import React from 'react'
import PropTypes from 'prop-types'
import { behaviourColors } from './constants'
import { useDispatch, useSelector } from 'react-redux'
import { selectBehaviour, selectTheme, setBehaviour } from './behaviourControlsSlice'
import { findSelectedStudents } from '../classState/studentsSlice'

/**
 * Button which changes the currently selected behaviour.
 * @param {*} props 
 */
const BehaviourButton = ({ behaviour, type, selectedImpulse }) => {
    const dispatch = useDispatch()

    const currentBehaviour = useSelector(selectBehaviour)
    const currentTheme = useSelector(selectTheme)
    const students = useSelector(findSelectedStudents)

    type = type || "behaviour"

    let color = behaviourColors[behaviour]
    let active = behaviour === (type === "theme" ? currentTheme : currentBehaviour)

    return (
        <button
            className={`btn btn-${color} ${active && 'active'}`}
            type='button'
            onClick={() => {
                if (behaviour === "evoke") {
                    console.log(`Evoke button clicked with impulse=${selectedImpulse}`);
                    dispatch(setBehaviour({ behaviour: selectedImpulse, type, students }));
                } else {
                    console.log(`Behaviour button clicked: behaviour=${behaviour}, type=${type}`);
                    if (behaviour === `Chatting+`) {
                        console.log("CHATTING+");
                    }
                    else {
                        console.log("OTHER BEHAVIOUR");
                    }
                    dispatch(setBehaviour({ behaviour, type, students }));
                }
            }}
            style={{ padding: '5px 4px', fontSize: '14px' }}
        >
            {behaviour}
        </button>
    );
}

BehaviourButton.propTypes = {
    /** Behaviour to switch to. */
    behaviour: PropTypes.string.isRequired,

    /** Type of the behaviour. */
    type: PropTypes.string
}

export default BehaviourButton